
import React from 'react';
import { useEffect, useState } from 'react';

//MUI components
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';


//Translate utils :
import { translator } from "../../../../utils/translator.js"
import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

//this component manage 1 select at a time
// props : horaire is 1 object with am and pm hours, closed or not
function DetailsHoraires({ horaires, activate }) { // destructuration à la déclaration : cover image, title of the house, id of house in database

    let textInfos = "";
    const lang = useSelector(getLang) //global state : language

    //convert datas from object 'horaires' (prop)
    const ouverture = horaires.am_start;
    const pauseDebut = horaires.am_end;
    const pauseFin = horaires.pm_start;
    const fermeture = horaires.pm_end;
    const ferme = (horaires.ferme === true); //is it closed today?

    if (activate) { //only when a spot is chosen

        if (ferme) { //shop closed that day
            textInfos = translator("Désolé, nous serons fermés à cette date.", lang, "horairesInfosClosed");
        }
        else {
            if (pauseDebut !== pauseFin) { //lunch break
                textInfos = `${translator("horaires d'ouvertures :", lang, "horairesInfosOpen")} ${ouverture}h00-${pauseDebut}h00 / ${pauseFin}h00-${fermeture}h00`;

            }
            else { //full day
                textInfos = `${translator("horaires d'ouvertures :", lang, "horairesInfosOpen")} ${ouverture}h00 - ${fermeture}h00`;

            }

        }
    }



    return (
        <div>
            <p className={`text-details-horaires ${ferme && 'info-closed-shop'}`}>{textInfos}</p>
        </div>

    )
}



export default DetailsHoraires
